import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { GuestProvider } from './GuestProvider';
import { LanguageProvider } from './LanguageContext';
import { SnackbarProvider } from './SnackbarContext';
import DayPage from './story-components/DayPage';

export default function App() {
  return (
    <>
      <SnackbarProvider>
        <GuestProvider>
          <LanguageProvider>
            <Router>
              <Routes>
                <Route path="/morning" element={<DayPage type="morning" />} />
                <Route path="/banquet" element={<DayPage type="banquet" />} />
              </Routes>
            </Router>
          </LanguageProvider>
        </GuestProvider>
      </SnackbarProvider>
    </>
  );
}
